import { Typography } from '@mui/material';
import { bagStatuses } from '@/constants/Bag';

export const ContainerCountField = record => {
    if (!record) return null;

    const containerCount = record.containerCount || 0;

    return (
        <Typography variant='body2' className={record.status === bagStatuses.in_progress ? 'gray' : ''}>
            {containerCount}
        </Typography>
    );
};
